var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnEyeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.198 7.00005C11.198 8.43472 10.0345 9.59742 8.59981 9.59742C7.16514 9.59742 6.00244 8.43472 6.00244 7.00005C6.00244 5.56455 7.16514 4.40186 8.59981 4.40186C10.0345 4.40186 11.198 5.56455 11.198 7.00005Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59901 13C11.728 13 14.59 10.7502 16.2013 7C14.59 3.24979 11.728 1 8.59901 1H8.6023C5.47329 1 2.61134 3.24979 1 7C2.61134 10.7502 5.47329 13 8.6023 13H8.59901Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEyeDark);
export default __webpack_public_path__ + "static/media/icn-eye-dark.fb90757a97b1838e1e79b1e295c54ce7.svg";
export { ForwardRef as ReactComponent };